import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Checkbox,
  Label,
} from 'prosci-ui';
import type { SkillFormData, UpdateField } from './skill-form';

type Props = {
  form: SkillFormData;
  updateField: UpdateField;
};

export function TemplateDetailsCard({ form, updateField }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Template Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-sm font-medium">Name (identifier)</label>
            <input
              type="text"
              className="w-full mt-1 px-3 py-2 border rounded-md text-sm"
              placeholder="cm-plan-builder"
              value={form.name}
              onChange={(e) => updateField('name', e.target.value)}
              maxLength={64}
            />
            <p className="text-xs text-muted-foreground mt-1">
              Unique identifier, lowercase with hyphens
            </p>
          </div>
          <div>
            <label className="text-sm font-medium">Display Title</label>
            <input
              type="text"
              className="w-full mt-1 px-3 py-2 border rounded-md text-sm"
              placeholder="Change Management Plan Builder"
              value={form.display_title}
              onChange={(e) => updateField('display_title', e.target.value)}
              maxLength={255}
            />
          </div>
        </div>

        <div>
          <label className="text-sm font-medium">Description</label>
          <textarea
            className="w-full mt-1 px-3 py-2 border rounded-md text-sm"
            rows={2}
            placeholder="Guides the AI through Prosci's CM plan methodology..."
            value={form.description}
            onChange={(e) => updateField('description', e.target.value)}
            maxLength={1024}
          />
        </div>

        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="text-sm font-medium">Skill Type</label>
            <Select
              value={form.skill_type}
              onValueChange={(v) => updateField('skill_type', v as SkillFormData['skill_type'])}
            >
              <SelectTrigger className="w-full mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="interactive">Interactive</SelectItem>
                <SelectItem value="template">Template</SelectItem>
                <SelectItem value="passive">Passive</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-sm font-medium">Execution Mode</label>
            <Select
              value={form.execution_mode}
              onValueChange={(v) => updateField('execution_mode', v as SkillFormData['execution_mode'])}
            >
              <SelectTrigger className="w-full mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="conversational">Conversational</SelectItem>
                <SelectItem value="guided">Guided</SelectItem>
                <SelectItem value="deliverable">Deliverable</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex items-end">
            <Label className="flex items-center gap-2 text-sm cursor-pointer">
              <Checkbox
                checked={form.is_active}
                onCheckedChange={(checked) => updateField('is_active', !!checked)}
              />
              Active
            </Label>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
